module.exports = __webpack_public_path__ + "static/media/confetti.5c7c7943.png";